import { httpRequest } from "@services/http";
import { EngagementContractDetail } from "./cmdGetEngagementContract";
import { ContractSerializer } from "@models/serializers/contractSerializer";
import { BudgetSerializer } from "@models/serializers/budgetSerializer";
import { PricesheetSerializer } from "@models/serializers/pricesheetSerializer";
import { PricesheetItemSerializer } from "@models/serializers/pricesheetitemSerializer";

export interface AssignEngagementContractPayload {
  contract_id: number;
}

export class CommandAssignEngagementContract {
  async run(
    engagementId: number,
    payload: AssignEngagementContractPayload,
  ): Promise<EngagementContractDetail> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/contract/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "POST",
        body: JSON.stringify(payload),
      });
      return {
        contract: ContractSerializer.fromJson(response.contract),
        budgets: BudgetSerializer.fromJsonList(response.budgets),
        pricesheets: PricesheetSerializer.fromJsonList(response.pricesheets),
        pricesheet_items: PricesheetItemSerializer.fromJsonList(
          response.pricesheet_items ?? [],
        ),
      };
    } catch (error) {
      console.error(`Error assigning contract to engagement ${engagementId}:`, error);
      throw error;
    }
  }
}